import styled from "styled-components";

interface ContentWrapperProps {
  itemExpanded: boolean;
}

export const Wrapper = styled.div`
  flex: 1 1 0;
  min-width: 0;

  .suggestion-list-header {
    box-sizing: border-box;
    padding-bottom: 5px;
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  width: 100%;  
  border-bottom: 1px solid #edeeee;
  margin-bottom: 10px;
`;

export const TitlesWrapper = styled.div`
  width: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  padding: 0 5px;
`;

export const TitleRow = styled.div`
  display:flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding-top: 5px;
`;

export const Details = styled.div`
  width: 100%;
  padding-bottom: 10px;
`;

export const RowDetails = styled.div`
  display:flex;
  flex-direction:row;
`;

interface ColDetailsProps {
  xs?: number;
}

export const ColDetails = styled.div<ColDetailsProps>` 
  border-bottom: 1px solid #edeeee;
  padding-bottom: 5px;
  ${(props) => (props.xs ? `flex: 0 0 ${(props.xs / 12) * 100}%; max-width: ${(props.xs / 12) * 100}%;` : "")}
`;

export const ContentWrapper = styled.div<ContentWrapperProps>`
  display: ${(props) => (props.itemExpanded ? "flex" : "none")};
  padding: 0 5px;
`;

export const InfosWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 5px;
`;

export const LastUpdateRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 5px;
`;

export const StockValueRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 5px;
  align-content: center;
  gap: 8px;
`;
